import React, { memo, useState, useCallback, useEffect } from "react";
import { Row, Col, Badge } from "react-bootstrap";
import { BsBookshelf } from "react-icons/bs";
import WidgetCard from "./WidgetCard";
import PropTypes from 'prop-types';
import TypeChart from "../main-page/TypeChart";
import CountUp from "react-countup";
import { useDispatch } from 'react-redux';
import { openModal } from "slices/stillageWidgetModalSlice";

const Count = memo(({ data, colour, title }) => {
    const dispatch = useDispatch();
    const [hovered, setHovered] = useState(false);
    const handleHover = hover => hover ? 'scale(1.1)' : 'scale(1)';

    const handleClick = useCallback(() => {
        dispatch(openModal({ title: title, data: data || [] }));
    }, [data, title]);

    // Always remove dupes from the count
    const uniqueNos = new Set(data?.map(x => x.stillageNo) || []);
    const dupeCount = data?.length - uniqueNos.size;
    const realTotal = data?.length - dupeCount;

    let dupes = null;
    if (dupeCount > 0 && colour === 'primary')
        dupes = <small>Duplicates: {dupeCount}</small>

    return (
        <div className="w-100">
            <Badge
                pill
                className="w-100"
                bg={colour}
                style={{ transform: handleHover(hovered), transition: 'transform 0.3s ease-in-out' }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={() => handleClick()}
            >{title}:{' '}
                <CountUp
                    className="fw-bold"
                    end={realTotal}
                    duration={3} />
                {dupes ? <><br />{dupes}</> : null}
            </Badge>
        </div>
    )
});

const Totals = ({ data, loading }) => {
    const [distinctData, setDistinctData] = useState([]);

    useEffect(() => setDistinctData([...new Map(data?.map(item => [item.stillageNo, item])).values()]), [data]);

    return (
        <WidgetCard title="Total Stillages" icon={<BsBookshelf />} loading={loading}>
            <Row className="h-100">
                <Col xs={8} className="h-100">
                    <TypeChart data={distinctData} loading={loading} />
                </Col>
                <Col xs={4} className="d-flex flex-column justify-content-between align-items-start">
                    <Count title={'Total'} colour='primary' data={data || []} />
                    <Count title={'Active'} colour='success' data={data?.filter(x => !x.lostStillage) || []} />
                    <Count title={'Lost'} colour='danger' data={data?.filter(x => x.lostStillage) || []} />
                </Col>
            </Row>
        </WidgetCard>
    )
}

Totals.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool
};

Count.propTypes = {
    data: PropTypes.array,
    colour: PropTypes.string,
    title: PropTypes.string
}

export default memo(Totals);